import "./v2-question-surface.css";

export default function ShareNote({ value, onChange }) {
  return (
    <label className="tgc-v2-share-note">
      <span className="tgc-v2-share-note__label">Add a few words (optional)</span>
      <textarea
        className="tgc-v2-share-note__field"
        value={value}
        maxLength={500}
        rows={3}
        placeholder="I made you something..."
        aria-label="Add a few words, optional"
        onChange={(event) => onChange(event.target.value.slice(0, 500))}
      />
    </label>
  );
}
